import { render, staticRenderFns } from "./BtnFavorite.vue?vue&type=template&id=2e3137f7&scoped=true&"
import script from "./BtnFavorite.vue?vue&type=script&lang=js&"
export * from "./BtnFavorite.vue?vue&type=script&lang=js&"
import style0 from "./BtnFavorite.vue?vue&type=style&index=0&id=2e3137f7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3137f7",
  null
  
)

export default component.exports